import { useMemo } from 'react'
import { doc } from 'firebase/firestore'
import type { DocumentReference } from 'firebase/firestore'
import { db } from '../lib/firebase'
import { useFirestoreDoc } from './useFirestore'
import type { Event } from '../types'

// One event doc by id. An unpublished event is unreadable to non-admins, so
// callers treat `error` as "no event" rather than surfacing it.
export function useEvent(eventId: string | undefined) {
  const ref = useMemo(
    () =>
      eventId
        ? (doc(db, 'events', eventId) as DocumentReference<Event>)
        : null,
    [eventId],
  )
  const { data: event, loading, error } = useFirestoreDoc(ref)
  return { event, loading, error }
}
